const REGEX_FORMAT_PHONE = /^(\d{2})(\d{5})(\d{4})|(\d{2})(\d{4})(\d{4})$/

const formatPhone = value => {
  if (value) {
    return value.replace(REGEX_FORMAT_PHONE, '($1$4) $2$5-$3$6')
  }

  return ''
}

export default formatPhone
